import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
// import deleteIcon from '../../assets/images/delete.svg';
import { Col, Input, Label, Row } from 'reactstrap';
import AdditionalDocument from './AdditionalDocument';

const AdditionalInformation = forwardRef(
	({ applicationId, onSave, onSubmit, data, onDataChange, isSubmitted }, ref) => {
		useImperativeHandle(ref, () => ({
			validate: validateForSubmit,
			getFormData: () => formData,
		}));
		const [formData, setFormData] = useState({
			publications: [{ name: '', url: '' }],
			socialMedia: [{ platform: 'X (Twitter)', url: '' }],
			termsAccepted: false,
			// additionalDocument: null
		});
		const [showValidation, setShowValidation] = useState(false);
		const [errors, setErrors] = useState({});

		// Load saved data when component mounts or data changes
		useEffect(() => {
			if (data) {
				setFormData((prevData) => ({
					...prevData,
					...data,
				}));
			}
		}, [data]);

		// console.log("AdditionalInformation received data:", data);
		// console.log("AdditionalInformation received data:", formData);

	const handleChange = (type, index, field, value) => {
		setFormData((prev) => {
			const updatedData = { ...prev };
			if (type === 'publications') {
				// Create a new array with new objects to ensure proper change detection
				updatedData.publications = updatedData.publications.map((pub, i) => {
					if (i === index) {
						if (field === 'file') {
							return { ...pub, file: value };
						} else {
							return { ...pub, [field]: value };
						}
					}
					return { ...pub }; // Create new object for all items
				});
			} else if (type === 'socialMedia') {
				// Create a new array with new objects
				if (field === 'platform' && value === 'NA') {
					// If user selects "NA", remove all social media entries and replace with single NA entry
					updatedData.socialMedia = [{ platform: 'NA', url: 'NA' }];
				} else {
					updatedData.socialMedia = updatedData.socialMedia.map((social, i) => {
						if (i === index) {
							return { ...social, [field]: value };
						}
						return { ...social }; // Create new object for all items
					});
				}
			} else {
				updatedData[field] = value;
			}
			onDataChange(updatedData);
			return updatedData;
		});
	};		const addNewItem = (type) => {
			setFormData((prev) => {
				const updatedData = { ...prev };
				if (type === 'publications') {
					if(updatedData.publications.length >= 5) return updatedData; // Max 5 publications
					updatedData.publications = [
						...updatedData.publications.map((pub) => ({ ...pub })),
						{ name: '', url: '', file: null },
					];
				} else if (type === 'socialMedia') {
					updatedData.socialMedia.push({ platform: '', url: '' });
				}
				onDataChange(updatedData);
				return updatedData;
			});
		};

		const removeItem = (type, index) => {
			setFormData((prev) => {
				const updatedData = { ...prev };
				if (type === 'publications') {
					updatedData.publications = updatedData.publications.filter((_, i) => i !== index);
				} else if (type === 'socialMedia') {
					updatedData.socialMedia = updatedData.socialMedia.filter((_, i) => i !== index);
				}
				onDataChange(updatedData);
				return updatedData;
			});
		};

	// Validation function for submit only
	const validateForSubmit = () => {
		const newErrors = {};

		// Validate publications: name required, file size <= 2MB
		if (formData.publications && formData.publications.length > 0) {
			formData.publications.forEach((pub, index) => {
				// if (!pub.name || !pub.name.trim()) {
				//     newErrors[`publication_${index}_name`] = 'Publication name is required.';
				// }
				if (pub.file && pub.file.size > 2 * 1024 * 1024) {
					newErrors[`publication_${index}_file`] = 'File too large. Maximum allowed size is 2MB.';
				}
			});
		}

		// Check if at least one social media entry exists
		if (!formData.socialMedia || formData.socialMedia.length === 0) {
			newErrors.social_required = 'At least one social media platform is required (or select NA).';
		} else {
			// Check if NA is selected
			const hasNA = formData.socialMedia.some(social => social.platform === 'NA');
			
			if (!hasNA) {
				// If NA is not selected, validate each social media profile
				const validSocials = formData.socialMedia.filter((social) => social.platform && social.platform !== 'NA');
				
				validSocials.forEach((social, index) => {
					if (!social.platform || !social.platform.trim()) {
						newErrors[`social_${index}_platform`] = 'Platform is required.';
					}
					if (!social.url || !social.url.trim()) {
						newErrors[`social_${index}_url`] = 'Social media URL is required when platform is selected.';
					}
				});
			}
			// If NA is selected, no further validation needed for social media
		}

		// Terms acceptance checkbox validation
		if (!formData.termsAccepted) {
			newErrors.termsAccepted = 'You must accept the Terms & Conditions to submit.';
		}

		setErrors(newErrors);
		setShowValidation(true);
		return Object.keys(newErrors).length === 0;
	};		return (
			<>
				<Row>
					<Col xl="12">
						<h2 className="personalinfo_head">Additional Information</h2>
					</Col>
				</Row>

				{/* Publications/Presentations Section */}
				{formData.publications.map((pub, index) => (
					<Row key={`pub-${index}`} className="align-items-center">
						<Col xl="12">
							<Col xl="12">
								{formData.publications.length > 1 && !isSubmitted && (
									<button
										type="button"
										className="remove_form"
										title="Delete publication"
										onClick={() => removeItem('publications', index)}>
										<img src={'../../assets/images/cross.svg'} alt="Delete" />
									</button>
								)}
							</Col>
						</Col>
						<Col xl="6">
							<div className="personal_formdetail">
								<h5>{index === 0 ? <>Publications </> : <>&nbsp;</>}</h5>
								<input
									type="text"
									className={`form-control form_custom${
										showValidation && errors[`publication_${index}_name`] ? ' is-invalid' : ''
									}`}
									placeholder="Name of publication"
									value={pub.name}
									onChange={(e) => handleChange('publications', index, 'name', e.target.value)}
									disabled={isSubmitted}
								/>
								{/* {showValidation && errors[`publication_${index}_name`] && (
                                <div className="invalid-feedback d-block">{errors[`publication_${index}_name`]}</div>
                            )} */}
							</div>
						</Col>

						<Col xl="6">
							<div className="personal_formdetail">
								<h5>&nbsp;</h5>
								<input
									type="url"
									className="form-control form_cap form_custom"
									placeholder="URL"
									value={pub.url}
									onChange={(e) => handleChange('publications', index, 'url', e.target.value)}
									disabled={isSubmitted}
								/>
							</div>
						</Col>

						<Col xl="12">
							<AdditionalDocument
								onFileSelect={(file) => {
									// Store file in the corresponding publication
									handleChange('publications', index, 'file', file);
								}}
								initialFile={pub.file}
								uploadLabel="Upload Publication File"
								uploadSubtext="Upload a file for this publication (PDF max 2MB)"
								multiple={false}
								disabled={isSubmitted}
								maxSize={2 * 1024 * 1024}
								accept={{ 'application/pdf': [] }}
							/>
							{showValidation && errors[`publication_${index}_file`] && (
								<div className="text-danger mt-2">{errors[`publication_${index}_file`]}</div>
							)}
						</Col>
					</Row>
				))}

				<Row className="mt-4">
					<Col xl="12">
						<button className="addnew" onClick={() => addNewItem('publications')} disabled={isSubmitted}>
							<span>+</span> Add New Publications
						</button>
					</Col>
				</Row>

				{/* Social Media Profiles Section */}
				{formData.socialMedia.map((social, index) => (
					<Row key={`social-${index}`}>
						<Col xl="12">
							<Col xl="12">
								{formData.socialMedia.length > 1 && !isSubmitted && social.platform !== 'NA' && (
									<button
										type="button"
										className="remove_form"
										title="Delete Social Media"
										onClick={() => removeItem('socialMedia', index)}>
										<img src={'../../assets/images/cross.svg'} alt="Delete" />
									</button>
								)}
							</Col>
						</Col>
						<Col xl="12">
							<div className="personal_formdetail">
								<h5>
									{index === 0 ? (
										<>
											Social Media Profiles <span className="text-danger">*</span>
										</>
									) : (
										''
									)}
								</h5>
								<div className="d-flex">
									<select
										className="select_gender me-2"
										style={{ width: '200px' }}
										value={social.platform}
										onChange={(e) => handleChange('socialMedia', index, 'platform', e.target.value)}
										disabled={isSubmitted}>
										<option value="">Select Platform</option>
										<option value="X (Twitter)">X (Twitter)</option>
										<option value="Facebook">Facebook</option>
										<option value="Instagram">Instagram</option>
										<option value="LinkedIn">LinkedIn</option>
										<option value="YouTube">YouTube</option>
										<option value="Other">Other</option>
										<option value="NA">NA</option>
									</select>
									{social.platform !== 'NA' && (
										<input
											type="url"
											className={`form-control form_custom form_cap flex-grow-1${
												showValidation && errors[`social_${index}_url`] ? ' is-invalid' : ''
											}`}
											placeholder="Https://X.Com/Narendramodi"
											value={social.url}
											onChange={(e) => handleChange('socialMedia', index, 'url', e.target.value)}
											disabled={isSubmitted}
										/>
									)}
								</div>
								{showValidation && errors[`social_${index}_url`] && (
									<div className="invalid-feedback d-block">{errors[`social_${index}_url`]}</div>
								)}
								{showValidation && errors.social_required && index === 0 && (
									<div className="invalid-feedback d-block">{errors.social_required}</div>
								)}
							</div>
						</Col>
					</Row>
				))}

				{/* Only show "Add Social Media" button if NA is not selected */}
				{!formData.socialMedia.some(social => social.platform === 'NA') && (
					<Row>
						<Col xl="12">
							<button className="addnew" onClick={() => addNewItem('socialMedia')} disabled={isSubmitted}>
								<span>+</span> Add Social Media handle
							</button>
						</Col>
					</Row>
				)}

				{/* Terms & Conditions Section */}
				<Row>
					<Col xl="12">
						<div className="rem_input custom-checkbox custom-control">
							<Input
								type="checkbox"
								id="confirm"
								className="custom-control-input"
								checked={formData.termsAccepted}
								onChange={(e) => handleChange(null, null, 'termsAccepted', e.target.checked)}
								disabled={isSubmitted}
							/>
							<Label className="custom-control-label" htmlFor="confirm">
								I confirm{' '}
								<a href="https://www.bluekraft.in/fellowship/term-condition/" target="__blank">
									{' '}
									Terms & Conditions
								</a>{' '}
								and understanding of the fellowship requirements and eligibility
							</Label>
						</div>
						{showValidation && errors.termsAccepted && <div className="text-danger mt-2">{errors.termsAccepted}</div>}
					</Col>
				</Row>
			</>
		);
	}
);

export default React.memo(AdditionalInformation);
